<template>
    <div class="dodel-category">
        <div class="dodel-page-header">
            <router-link :to="{name: 'categories'}"> 
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"/></svg> {{translate('Back')}}
            </router-link>
            <div class="dodel-screen-title" v-html=category_name></div>
        </div>
        <div class="dodel-meals">
            <div class="dodel-meal-container" v-for="meal in meals" :key="meal.ID">
                <div class="dodel-meal" @click="add_to_cart(meal)">
                    <img :src="meal.thumbnail" :alt="meal.post_title">
                    <div v-html="meal.post_title"></div>
                    <div>{{meal_calories(meal)}} {{translate('Cals')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'category',
    computed: {
        category_name(){
            let category
            this.$store.state.menu.forEach(item=>{
                if(item.term_id == this.$route.params.id)
                    category = item
            })
            if(category && category.name)
                return category.name
            return ''
        },
        meals(){
            let category
            this.$store.state.menu.forEach(item=>{
                if(item.term_id == this.$route.params.id)
                    category = item
            })
            if(category && category.children)
                return category.children
            return ''
        }
    },
    methods: {
        add_to_cart(meal){
            meal.include = true
            meal.nutritions = meal.nutritions.map(item=>{
                item.include = true
                return item
            })
            this.$store.commit('add_to_cart', meal)
            this.$router.push({name: 'cart'})
        },
        translate(string){
            return this.$store.state.language[string]
        },
        meal_calories(meal){
            let calories = 0
            meal.nutritions.forEach(nutrition => {
                calories+=parseFloat(nutrition.calories)
            })
            const cals = Math.round(calories)
            if(cals==calories)
                return calories
            return calories.toFixed(2)
        }
    }
}
</script>

<style>
    .dodel-meals{
        display: flex;
        flex-wrap: wrap;
    }
    .dodel-meals .dodel-meal{
        background: #fff;
        border-radius: 4px;
        border: 1px solid rgba(0,0,0,.2);
        box-shadow: 0 1px 2px rgba(0,0,0,.05);
        text-align: center;
        padding: 10px;
        cursor: pointer;
    }
    .dodel-meals .dodel-meal:hover{
        box-shadow: 0 3px 3px rgb(0 0 0 / 5%);
    }
    .dodel-meals .dodel-meal div{
        height: 2.4em;
        line-height: 1.2em;
        margin-top: 1em;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .dodel-meals .dodel-meal-container{
        flex-basis: 25%;
        padding: 10px;
        box-sizing: border-box;
    }
    .dodel-meals .dodel-meal img{
        max-width: 100%;
    }
    @media screen and (max-width: 768px){
        .dodel-meals{
            display: block;
        }
    }
</style>